import { render, staticRenderFns } from "./Additions.vue?vue&type=template&id=23984143&"
import script from "./Additions.vue?vue&type=script&lang=js&"
export * from "./Additions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports